import {
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  Ref,
} from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import LoadingModal from '../../../../components/modals/LoadingModal';

export type TutorAssignmentDownloadingMethods = {
  open: (key: string) => void;
  close: () => void;
};

type TutorAssignmentDownloadingProps = {
  onClose?: () => void;
};

const TutorAssignmentDownloading = (
  { onClose }: TutorAssignmentDownloadingProps,
  ref: Ref<TutorAssignmentDownloadingMethods>,
) => {
  const [key, setKey] = useState<string>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { t } = useTranslation(
    TranslationsKeys.TUTOR_MANAGEMENT_TUTOR_ASSIGNMENT,
  );

  const close = useCallback(() => {
    setIsOpen(false);
    !!onClose && onClose();
  }, [onClose]);

  const open = useCallback((nextKey: string) => {
    setKey(nextKey);
    setIsOpen(true);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <LoadingModal
      isOpen={isOpen}
      title={t(`downloading.${key}.title`)}
      description={t(`downloading.${key}.description`)}
    />
  );
};

export default forwardRef(TutorAssignmentDownloading);
